<!-- Capa translúcida del chasis de la liga: deja ver la pantalla detrás y dice qué pasa. -->
<div class="loader-container" role="status" aria-live="polite">
  <div class="loader-tarjeta">
    <div class="spinner" aria-hidden="true"></div>
    <h2>{{currentMessage}}</h2>
    <p>No cierres esta pantalla.</p>
  </div>
</div>
